import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import 'rxjs/add/operator/map'
import { Test } from '../models/Test';
import { PlatformLocation } from '@angular/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TestService {

  constructor(
    private http: HttpClient, private location: PlatformLocation ) { }

  getTests(): Observable<Test[]> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.get<Test[]>(this.location.getBaseHrefFromDOM() +'api/tests', { headers: headers });
  }

  filterTests(siteId: number, search: string, sourceCode : string) {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");
    return this.http.get<Test[]>(this.location.getBaseHrefFromDOM() + `api/tests?siteId=${siteId}&search=${encodeURIComponent(search)}&source=${encodeURIComponent(sourceCode)}`, { headers: headers });
  }
}
